exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper-frea_{position:relative;margin-bottom:80px}.tabContainer-XQaAN{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex}.tabContainer-XQaAN:after{position:absolute;bottom:1px;display:block;width:100%;height:1px;background-color:rgba(255,255,255,.3);content:\"\"}.underline-2cvX3{position:absolute;bottom:0;left:0;width:0;height:3px;background-color:#0a81ff;-webkit-transition:.3s ease-out;transition:.3s ease-out}.theme-dark .tabContainer-XQaAN:after{background-color:rgba(255,255,255,.3)}.theme-dark .underline-2cvX3{background-color:#0a81ff}.theme-light .tabContainer-XQaAN:after{background-color:#bababa}.theme-light .underline-2cvX3{background-color:#0070b6}", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper-frea_",
	"tabContainer": "tabContainer-XQaAN",
	"underline": "underline-2cvX3"
};